import { colors } from 'components/styles/variables';
import css from 'styled-jsx/css';

const styles = css`
  .dropdown-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 248px;
    padding: 8px;
    width: 100%;
  }
  .dropdown-title {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.2px;
    padding-left: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .header-disabled {
    color: ${colors.G3};
  }
`;
export default styles;
